import React, { useCallback, useState } from 'react'
import { Box } from '@mui/material'
import { useLocation } from 'react-router-dom'
import { EditModeProvider } from '../dashboard/useEditMode'
import { CurrentRoleProvider } from '../currentRole'
import AdvancedThemeProvider from '../AdvancedThemeProvider'
import { TourRequestProvider } from '../tour/tourRequest'
import AdvancedAppBar, { ADVANCED_APP_BAR_HEIGHT } from './AdvancedAppBar'

const AdvancedShell = ({ children }: { children: React.ReactNode }) => {
  const location = useLocation()
  // A request no patient answered lapses on navigation.
  const [tourLocation, setTourLocation] = useState<typeof location | null>(null)
  const onTourHandled = useCallback(() => setTourLocation(null), [])

  return (
    <CurrentRoleProvider>
      <EditModeProvider>
        <AdvancedThemeProvider>
          <AdvancedAppBar onStartTour={() => setTourLocation(location)} />
        </AdvancedThemeProvider>

        <Box height={`calc(100% - ${ADVANCED_APP_BAR_HEIGHT}px)`}>
          <TourRequestProvider requested={tourLocation === location} onHandled={onTourHandled}>
            {children}
          </TourRequestProvider>
        </Box>
      </EditModeProvider>
    </CurrentRoleProvider>
  )
}

export default AdvancedShell
